import { IKeyNumberDict } from "@/types/GlobalTypes";

/**
 * Counts elements in an array, returns object.
 * Reference:
 *   https://stackoverflow.com/questions/19395257/how-to-count-duplicate-value-in-an-array-in-javascript
 * @example
 *   getArrayElementCounts(["a", "b", "c", "a"])
 * @param ary The array to check.
 * @returns {object: {string: any}} {"a": 2, "b": 1, "c": 1};
 */
 function getArrayElementCounts(ary: any[]): IKeyNumberDict {
	const counts = {};
	ary.forEach((x) => {
		counts[x + ""] = (counts[x + ""] || 0) + 1;
	});
	return counts;
}

/**
 * Used as filter lambda function.
 * Reference: https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
 * @param value Current value of the iterator.
 * @param index Current index of the iterator.
 * @param self Reference to the array itself.
 * @returns {any[]} Only unique elements (remove duplicates) of an array.
 * @deprecated Use Set instead
 */
function onlyUnique(value: any, index: number, self: any[]): boolean {
	return self.indexOf(value) === index;
}

export {
	getArrayElementCounts,
	onlyUnique
}